import { normalizeConfiguration } from "@/helpers/keyBuilder"
import { useCallback } from "react"

export const useNormalizeConfiguration = () => useCallback(params => normalizeConfiguration(params), [])
